import { Subject } from "rxjs";
import { OnDestroy } from "@angular/core";

export type Alignment = "flex-start" | "flex-end" | "center" | "stretch";
export type Justification =
  | "flex-start"
  | "flex-end"
  | "center"
  | "space-around"
  | "space-between";
export type Direction = "row" | "row-reverse" | "column" | "column-reverse";
export type FlexWrap = "nowrap" | "wrap" | "wrap-reverse";

export abstract class FlexComponent implements OnDestroy {
  static LOGS: "verbose" | "mute" = "verbose";

  public flex: boolean;
  public alignment: Alignment;
  public selfAlignment: Alignment;
  public justification: Justification;
  public direction: Direction;
  public fix: boolean;
  public wrap: FlexWrap;
  public additionClasses: string[];

  private _classes = "component";
  public get classes(): string {
    return this._classes;
  }
  public set classes(v: string) {
    this._classes = `component ${v} ${this.additionClasses.join(" ")}`;
  }

  private destroySubject = new Subject();
  protected destroy = this.destroySubject.asObservable();

  constructor() {
    this.flex = true;
    this.fix = true;
    this.alignment = "stretch";
    this.justification = "flex-start";
    this.direction = "column";
    this.wrap = "nowrap";
    this.additionClasses = [];
  }

  // tslint:disable-next-line: use-life-cycle-interface
  ngOnDestroy() {
    this.destroySubject.next();
    this.destroySubject.complete();
    if (FlexComponent.LOGS === "verbose") {
      console.log("FlexComponent destroyed", this.destroySubject);
    }
  }
}
